import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import MultiSelectDropdown from './multi_select_dropdown'

class MultiSelectDropdownForm extends PureComponent {

	render() {
		/*if(this.props.meta.error || this.props.error || this.props.input.error) {
			console.log('I HAVE RROR:', this.props)
		}*/
		//console.log(this.props)

		return <MultiSelectDropdown
			tabIndex={this.props.tabIndex}
			fontSize={this.props.fontSize}
			positionTop={this.props.positionTop}
			placeholder={this.props.placeholder}
			options={this.props.options}
			onChange={this.props.onChange}
			message={this.props.getMessage(this.props.meta, this.props.input.name)}
			field={{
				value: this.props.input.value,
				initialValue: this.props.input.initialValue,
				onChange: this.props.input.onChange,
			}}
		/>
	}
}
MultiSelectDropdownForm.propTypes = {
	fontSize: PropTypes.oneOf(['small', 'medium', 'big']),
}

MultiSelectDropdownForm.defaultProps = {
	getMessage: () => '',
}

export default MultiSelectDropdownForm
